document.addEventListener('alpine:init', () => {
    Alpine.data('sidebarAdvert', () => ({
        init() {
        },
    }));
});
